import type { DecisionKind, ProposalState, SkipReason } from '../trip-accessorials.api';

const TYPE_LABELS: Record<string, string> = {
  extra_offloading_point: 'Extra offloading point',
  night_weekend_delivery: 'Night or weekend delivery',
  waiting: 'Waiting time',
  diversion: 'Diversion',
};

/** The catalogue code as a person would say it, for a type this screen has no wording for yet. */
export function accessorialLabel(code: string): string {
  return TYPE_LABELS[code] ?? code.replace(/_/g, ' ').replace(/^./, (first) => first.toUpperCase());
}

export const STATE_LABELS: Record<ProposalState, string> = {
  open: 'Awaiting a decision',
  confirmed: 'Confirmed',
  adjusted: 'Adjusted',
  dropped: 'Dropped',
  stale: 'Out of date',
};

export const STATE_HINTS: Partial<Record<ProposalState, string>> = {
  stale: 'The timeline changed after this was decided, so the decision no longer counts. Decide again.',
};

export const SKIP_REASON_TEXT: Record<SkipReason, string> = {
  no_price_on_job: 'This job was not priced with this charge.',
  nothing_due: 'Nothing is due on this trip.',
  no_data: 'The timeline has no events to work this out from.',
  waiting_start_event_missing: 'The log does not record when waiting started, so it cannot be worked out.',
  diversion_not_supported: 'Diversions are not recorded yet, so none can be proposed.',
};

/** Past tense, naming the charge, for the toast once the server has confirmed the decision. */
export function decisionToast(proposalKey: string, decision: DecisionKind): string {
  return `${accessorialLabel(proposalKey)} charge ${decision}`;
}
